import React from "react";

const AlertCircleIcon = ({ style, size = 16, color = "#C13842" }) =>
  <svg width={size} height={size} style={style} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2937_357)">
      <path d="M7.9987 5.33398V8.00065M7.9987 10.6673H8.00536M14.6654 8.00065C14.6654 11.6825 11.6806 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6825 1.33203 8.00065C1.33203 4.31875 4.3168 1.33398 7.9987 1.33398C11.6806 1.33398 14.6654 4.31875 14.6654 8.00065Z" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2937_357">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>

  ;

export default AlertCircleIcon;

